import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type StudentImportService from 'teacher-ui-client/services/student-import'
import type RouterService from '@ember/routing/router-service'

export default class ValidateRoute extends Route {
  @service
  studentImport!: StudentImportService

  @service
  router!: RouterService

  beforeModel() {
    // Only proceed if there's a file set, and this file hasn't undergone validation
    if (!this.studentImport.importJob.file || this.studentImport.importJob.valid !== undefined) {
      void this.router.replaceWith('manage.students')
    }
  }

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    return { subscriptionType }
  }
}
